import { Alert, AlertTitle } from '@mui/material'

export default function Error({
  description,
  retry,
  severity = 'error',
  title = 'An error occurred',
  style
}) {
  return (
    <Alert severity={severity} style={{ minWidth: 200, ...style }}>
      <AlertTitle>
        {title}
        {retry && (
          <span className='text-primary cursor-pointer user-select-none ml-2 px-1' onClick={retry}>
            <i className='fa fa-arrow-rotate-right' /> Retry
          </span>
        )}
      </AlertTitle>
      {description && (
        <strong style={{ display: 'block', maxHeight: 150, overflow: 'auto' }}>
          {description?.props?.children ?? description.toString()}
        </strong>
      )}
    </Alert>
  )
}
